<template>
  <p v-if="disconnectedMode">
    The tracking API is only available in connected, integrated, or headless modes.
  </p>
  <div v-else>
    <h3>Test-Tracker Component</h3>
    <fieldset class="form-group col-sm">
      <legend>Page View</legend>
      <p>
        Track arbitrary page views for custom routing or offline use. Note that Layout Service
        tracks page views by default unless <code>tracking=false</code> is passed in its query
        string.
      </p>
      <p class="alert alert-warning">
        Leaving the <em>Page Item GUID</em> field blank will use the current page's ID and URL.
      </p>
      <label for="pageId">Page Item GUID</label>
      <input
        type="text"
        class="form-control"
        id="pageId"
        v-model="txtPageId"
        placeholder="i.e. {11111111-1111-1111-1111-111111111111}"
      />
      <br />
      <label for="pageUrl">Page URL</label>
      <input
        type="text"
        class="form-control"
        id="pageUrl"
        v-model="txtPageUrl"
        placeholder="i.e. /foo/bar"
      />
      <button type="button" class="btn btn-primary mt-3" v-on:click="submitPageView">Submit</button>
    </fieldset>
    <fieldset class="form-group col-sm">
      <legend>Interaction Control</legend>
      <p>
        Tracking data is not pushed into the xConnect service until your session ends on the
        Sitecore server. Click this button to instantly end your session and flush the data - great
        for debugging and testing.
      </p>
      <p class="alert alert-warning">
        Note: By default <em>anonymous</em> contacts will not be shown in Experience Profile. If
        your interactions are not showing up in Experience Profile, you may need to
        <a
          href="https://doc.sitecore.net/developers/xp/xconnect/xconnect-search-indexer/enable-anonymous-contact-indexing.html"
        >
          enable anonymous contact indexing.
        </a>
      </p>
      <button type="button" class="btn btn-primary" v-on:click="abandonSession">
        End Interaction
      </button>
    </fieldset>
  </div>
</template>

<script>
import { trackingApi } from '@sitecore-jss/sitecore-jss/tracking';
import { dataFetcher } from '../dataFetcher';
import config from '../temp/config';

export default {
  name: 'Test-Tracker',
  components: {},
  props: {
    fields: {
      type: Object,
      default: () => ({})
    }
  },
  data: () => ({
    txtPageId: '',
    txtPageUrl: ''
  }),
  computed: {
    trackingApiOptions() {
      return {
        host: config.sitecoreApiHost,
        querystringParams: {
          sc_apikey: config.sitecoreApiKey
        },
        fetcher: dataFetcher
      };
    },
    disconnectedMode() {
      // If the itemId is an actual GUID then the site is running in connected mode.
      var guidPattern = new RegExp(
        '^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$',
        'i'
      );
      return !guidPattern.test(this.$jss.sitecoreContext().itemId);
    }
  },
  methods: {
    submitPageView() {
      const event = this.txtPageId?.trim()
        ? { pageId: this.txtPageId, url: this.txtPageUrl }
        : { pageId: this.$jss.sitecoreContext().itemId, url: this.$jss.sitecoreContext().itemPath };
      trackingApi
        .trackEvent([event], this.trackingApiOptions)
        .then(console.log('Page view pushed:', event))
        .catch((error) => console.error(error, event));
    },
    abandonSession() {
      const abandonOptions = {
        action: 'flush',
        ...this.trackingApiOptions
      };
      trackingApi
        .trackEvent([], abandonOptions)
        // .then(() => console.log('Interaction has been terminated and its data pushed to xConnect.'))
        .catch((error) => console.error(error));
    }
  }
};
</script>
